import { api } from './base';

import { MutationArg } from 'v2/types';
import { AdModel, CasinoAdModel } from 'v2/types/AdModel';
import { SWRKeyValue } from 'v2/types/swr';

export const adsService = {
  getAds(): Promise<AdModel[]> {
    return api.get('v1/admin/ad').json();
  },

  createAd(_key: string, { arg }: MutationArg<Omit<AdModel, 'id'>>): Promise<AdModel> {
    return api.post('v1/admin/ad', { json: arg }).json();
  },

  updateAd([_key, adId]: SWRKeyValue, { arg }: MutationArg<Omit<AdModel, 'id'>>): Promise<AdModel> {
    return api.put(`v1/admin/ad/${adId}`, { json: arg }).json();
  },

  deleteAd([_key, adId]: SWRKeyValue): Promise<AdModel> {
    return api.delete(`v1/admin/ad/${adId}`).json();
  },

  getCasinoAds(): Promise<CasinoAdModel[]> {
    return api.get('v1/admin/casino-ad').json();
  },

  createCasinoAd(_key: string, { arg }: MutationArg<Omit<CasinoAdModel, 'id'>>): Promise<CasinoAdModel> {
    return api.post('v1/admin/casino-ad', { json: arg }).json();
  },

  updateCasinoAd([_key, adId]: SWRKeyValue, { arg }: MutationArg<Omit<CasinoAdModel, 'id'>>): Promise<CasinoAdModel> {
    return api.put(`v1/admin/casino-ad/${adId}`, { json: arg }).json();
  },

  deleteCasinoAd([_key, adId]: SWRKeyValue): Promise<CasinoAdModel> {
    return api.delete(`v1/admin/casino-ad/${adId}`).json();
  },
};
